<template>
  <div>
    <div v-for="(question, index) in questions" v-show="activeLocalStep(index)" :key="index">
      <StepTitle :value="question.title" class="mb-8" />

      <div>
        <div class="form-group" :class="{ 'form-group-invalid': hasErrors && index === 0 }">
          <div class="flex justify-between px-0.5">
            <label :for="'fast-project-description-' + index" class="text-body-color">{{ question.label }}</label>
            <span v-if="closeToMaxLength">{{ combinedDescription.length }}&#8239;/&#8239;{{ maxLength }}</span>
          </div>
          <textarea
            :id="'fast-project-description-' + index"
            ref="answerAreas"
            v-model="answers[index]"
            name="project_description"
            class="form-control js-not-auto-submit rounded-lg py-4"
            :class="{ 'is-invalid': hasErrors && index === 0 }"
            :placeholder="question.placeholder"
            autocomplete="off"
            rows="8"
            :maxlength="remainingMaxLength"
            tabindex="-1"
            style="line-height: 145% !important"
          ></textarea>
          <div v-if="hasErrors && index === 0" class="invalid-feedback">
            Votre description {{ mainStore.errors.description | toSentence }}.
          </div>
        </div>
      </div>

      <div v-html="mainStore.currentStepContent.reassurance"></div>

      <portal v-if="active" to="fast-footer">
        <StepNav :next-disabled="!completed" @goToPrev="retreat" @goToNext="proceed" />
      </portal>
    </div>
  </div>
</template>

<script>
import { mapStores } from 'pinia'
import { STEPS, useMainStore } from '@/apps/fast/store'

export default {
  data() {
    return {
      answers: [''],
      localStep: 0,
      remainingMaxLength: null
    }
  },
  computed: {
    ...mapStores(useMainStore),
    active() {
      return this.mainStore.step === STEPS.description
    },
    questions() {
      return Object.values(this.mainStore.stepContent(STEPS.description).questions)
    },
    combinedDescription() {
      let combined = ''
      this.answers.forEach((answer, index) => {
        if (typeof answer === 'string' && answer.length > 0) {
          if (index > 0) {
            combined += '\n\n'
          }
          if (this.answers.length > 1) combined += `${this.questions[index].insert} :\n\n${answer}`
          else combined += answer
        }
      })
      return combined
    },
    combinedLength() {
      return this.combinedDescription.length
    },
    closeToMaxLength() {
      return this.maxLength - 500 <= this.combinedLength
    },
    hasErrors() {
      return this.mainStore.errors.description?.length > 0
    },
    completed() {
      return this.$root.cleanText(this.answers[this.localStep]).length >= this.minLength
    },
    minLength() {
      return this.mainStore.stepContent(STEPS.description).minimumLength || 10
    },
    maxLength() {
      return this.mainStore.stepContent(STEPS.description).maximumLength || 8000
    },
    skipLength() {
      return this.mainStore.stepContent(STEPS.description).skipMinimumLength || 20
    },
    wellDescribed() {
      return this.answers[0].length >= this.skipLength && this.$root.cleanText(this.answers.slice(1).join('')).length === 0
    }
  },
  mounted() {
    this.remainingMaxLength = this.maxLength
  },
  methods: {
    enter() {
      this.goToLocalStep()
    },
    proceed() {
      if (!this.completed) return

      this.mainStore.wellDescribed = this.wellDescribed
      if ((this.localStep === 0 && this.wellDescribed) || this.localStep === this.questions.length - 1) {
        this.mainStore.requestBody.project.description = this.combinedDescription
        this.mainStore.goToNextStep()
      } else {
        this.goToLocalStep(this.localStep + 1)
      }
    },
    retreat() {
      if (this.localStep === 0) {
        this.mainStore.goToPreviousStep()
      } else {
        this.goToLocalStep(this.localStep - 1)
      }
    },
    activeLocalStep(descStep) {
      return descStep === this.localStep
    },
    goToLocalStep(step = null) {
      if (step !== null) {
        this.localStep = step
      }
      let eventName = 'description'
      if (this.localStep > 0) {
        eventName += '-' + (this.localStep + 1)
      }
      this.remainingMaxLength = this.maxLength - this.combinedLength
      this.$root.sendMatomoPageView(eventName)
      this.setProgress()

      this.$nextTick(() => {
        if (!this.$root.isAndroid()) {
          this.$refs.answerAreas[this.localStep].focus()
        }
      })
    },
    setProgress() {
      this.mainStore.changeCurrentStepProgress(100 * (1 + this.localStep / this.questions.length))
    }
  }
}
</script>
